(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ixlaser-client-workspace"] && !Shopify.designMode) return;
  try {
    
function setupClientWorkspace(root){if(root.dataset.cjmReady)return;root.dataset.cjmReady='true';const buttons=root.querySelectorAll('[data-cjm-panel]');buttons.forEach(button=>button.addEventListener('click',()=>{buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-cjm-view]').forEach(panel=>{panel.hidden=panel.dataset.cjmView!==button.dataset.cjmPanel})}))}document.querySelectorAll('.cjm').forEach(setupClientWorkspace);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.cjm').forEach(setupClientWorkspace));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
